// extracted by mini-css-extract-plugin
export default {"container":"c9a3e711","title":"a8b02fe8"};